import { ReactNode } from 'react';

import { HashTable } from '@/shared/components/atoms/LanguageSelector/LanguageSelector';

import Egypt from '~/images/flags/Egypt.svg';
import England from '~/images/flags/England.svg';
import France from '~/images/flags/France.svg';
import Gorgia from '~/images/flags/Gorgia.svg';
import Spain from '~/images/flags/Spain.svg';

export const LangList: HashTable<{ name: string; flag: ReactNode }> = {
  en: { name: 'English', flag: <England /> },
  ar: { name: 'العربية', flag: <Egypt /> },
  es: { name: 'Español', flag: <Spain /> },
  fr: { name: 'Français', flag: <France /> },
  ka: { name: 'ქართველი', flag: <Gorgia /> },
};

// Map of country codes to language codes
export const countryToLanguageMap: { [key: string]: string } = {
  // English-speaking countries
  US: 'en',
  GB: 'en',
  AU: 'en',

  // Arabic-speaking countries
  EG: 'ar',
  SA: 'ar',
  AE: 'ar',

  // Spanish-speaking countries
  ES: 'es',
  MX: 'es',
  AR: 'es',

  // French-speaking countries
  FR: 'fr',
  BE: 'fr',
  CA: 'fr',

  // Georgian
  GE: 'ka',
};
